import { ReactionsCommentsQuery, ReactionsContentQuery } from '../hooks/useReactionsData.ts';
import type { useReactionsDataContentQuery$data as ContentQueryData } from '../hooks/__generated__/useReactionsDataContentQuery.graphql.ts';
import type { useReactionsDataCommentsQuery$data as CommentsQueryData } from '../hooks/__generated__/useReactionsDataCommentsQuery.graphql.ts';
import type { QueryData, ReactionsData } from '../reactionTypes.ts';

type getReactionsSummaryFn = (data?: QueryData | null) => ReactionsData | null | undefined;

export const getReactionsSummary: getReactionsSummaryFn = (data) => {
	if (!data) {
		return data;
	}

	if (isContentReactions(data)) {
		return data?.content?.nodes?.[0]?.contentReactionsSummary;
	}

	if (isCommentReactions(data)) {
		return data?.comments?.nodes?.[0]?.reactionsSummary;
	}
};

const isContentReactions = (data: QueryData): data is ContentQueryData => 'content' in data;

const isCommentReactions = (data: QueryData): data is CommentsQueryData => 'comments' in data;

export const getReactionsQueryInfo = (isComment, contentId, containerId) => {
	const query = isComment ? ReactionsCommentsQuery : ReactionsContentQuery;
	const queryVariables = isComment ? { contentId, containerId } : { contentId };

	return { query, queryVariables };
};
